import { computed, inject, Injectable, linkedSignal } from '@angular/core';
import { HybridService } from '@core/hybrid/hybrid.service';
import { MediaQueryService } from '@core/services/media-query.service';

@Injectable({ providedIn: 'root' })
export class NavigationPanelService {
    private readonly hybridService = inject(HybridService);
    private readonly mediaQueryService = inject(MediaQueryService);

    private readonly isOnMobile = computed(() =>
        this.hybridService.isHybrid() || new Set(['xs', 'sm', 'md']).has(this.mediaQueryService.activeMediaQuery())
    );

    readonly isVisible = linkedSignal(() => this.isOnMobile());

    show(): void {
        this.isVisible.set(true);
    }

    hide(): void {
        this.isVisible.set(false);
    }
}
